import { AHIcon, AHText, Box, ColorType, IconSize, TopTabItem } from "arkh";
import { iconNames } from "arkh/src/cross-platform/AHIcon/fonts/icon-types";
import { useState } from "react";
import { View } from "react-native";

const sizes: IconSize[] = ["xxsmall", "xsmall", "small", "medium", "large"];

const colors: ColorType[] = [
  "text-primary",
  "text-washed",
  "text-secondary",
  "text-cta",
];

export function IconPlayground() {
  const [color, setColor] = useState<ColorType>("text-washed");
  const [size, setSize] = useState<IconSize>("medium");
  return (
    <Box space="large">
      <View style={{ flexDirection: "row" }}>
        {colors.map((c) => (
          <TopTabItem
            key={c}
            selected={color === c}
            onPress={() => {
              setColor(c);
            }}
          >
            {c}
          </TopTabItem>
        ))}
      </View>
      <View style={{ flexDirection: "row" }}>
        {sizes.map((s) => (
          <TopTabItem
            key={s}
            selected={size === s}
            onPress={() => {
              setSize(s);
            }}
          >
            {s}
          </TopTabItem>
        ))}
      </View>
      <Box
        spaceVertical="medium"
        style={{ flexDirection: "row", flexWrap: "wrap" }}
        gap="medium"
      >
        {iconNames.map((icon) => (
          <View
            key={icon}
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <View
              style={{
                height: 50,
                width: 50,

                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AHIcon key={size} type={icon} color={color} size={size} />
              <AHText
                spaceTop="xsmall"
                numberOfLines={1}
                size={6}
                type="info-small"
              >
                {icon}
              </AHText>
            </View>
          </View>
        ))}
      </Box>
    </Box>
  );
}
